<template>
  <v-card class="card-shadow">
    <v-subheader class="body-1 primary">
      <div class="ma-0 pa-0 white--text">
        <label class="font-weight-medium">My Ratings</label>
      </div>
    </v-subheader>
    <v-divider />
    <div v-if="current_applicant.specificSelectorExists">
      <v-card-text>
        <v-col cols="10">
          <div class="d-flex flex-column">
            <div class="d-flex flex-row justify-space-between">
              <div class="body-1 ma-0 pa-0 d-flex align-center">
                Academic Record
              </div>
              <div class="d-flex flex-row align-center justify-center">
                <v-rating
                  class="hidden-sm-and-down"
                  background-color="primary"
                  color="primary"
                  readonly
                  dense
                  :value="current_applicant.academicRating"
                  :length="6"
                ></v-rating>
                <span>({{ current_applicant.academicRating }}/6)</span>
              </div>
            </div>
            <div class="d-flex flex-row justify-space-between">
              <div class="body-1 ma-0 pa-0 d-flex align-center">Experience</div>
              <div class="d-flex flex-row align-center justify-center">
                <v-rating
                  class="hidden-sm-and-down"
                  background-color="primary"
                  color="primary"
                  readonly
                  dense
                  :value="current_applicant.experienceRating"
                ></v-rating>
                <span>({{ current_applicant.experienceRating }}/5)</span>
              </div>
            </div>
            <div class="d-flex flex-row justify-space-between">
              <div class="body-1 ma-0 pa-0 d-flex align-center">
                Overall Rating
              </div>
              <div class="d-flex flex-row align-center justify-center">
                <v-rating
                  class="hidden-sm-and-down"
                  background-color="primary"
                  color="primary"
                  readonly
                  dense
                  :value="current_applicant.overallRating"
                  :length="4"
                ></v-rating>
                <span>({{ current_applicant.overallRating }}/4)</span>
              </div>
            </div>
          </div>
        </v-col>
      </v-card-text>
      <div class="d-flex justify-center">
        <v-btn
          depressed
          class="ma-4 text-capitalize"
          color="primary"
          dark
          @click="onRateEditClicked()"
          >Edit Ratings</v-btn
        >
      </div>
    </div>

    <div v-else class="card-shadow d-flex flex-column">
      <label class="body-1 grey--text text--darken-2 mx-4 mt-4">
        Your Ratings will appear here after you rate the applicant.
      </label>
      <v-btn depressed class="align-self-start ma-4 text-capitalize" color="primary" dark @click="onRateClicked()"
        >Rate applicant</v-btn
      >
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'MyRatings',
  props: {
    current_applicant: {
      type: Object,
      required: true,
    },
  },
  methods: {
    onRateEditClicked() {
      this.$emit('onRateEditClicked');
    },
    onRateClicked() {
      this.$emit('onRateClicked');
    },
  },
};
</script>

<style scoped>
.card-shadow {
  box-shadow: 0px 0px 75px #00000024 !important;
}
</style>
